import * as React from 'react';
import { Text } from '../Text';
import { CALENDAR_DATA_KEYS } from './dataHooks';
import { st, classes } from './CalendarCell.st.css';
import { CalendarCellAlignment, CalendarCellTimes, } from './types';
/** CalendarCell */
export class CalendarCell extends React.Component {
    getDataAttributes() {
        const { stretchable, current, timeType, alignment } = this.props;
        return {
            [CALENDAR_DATA_KEYS.Stertchable]: stretchable,
            [CALENDAR_DATA_KEYS.TimeType]: timeType,
            [CALENDAR_DATA_KEYS.Current]: current,
            [CALENDAR_DATA_KEYS.Alignment]: alignment,
        };
    }
    render() {
        const { title, children, stretchable, current, alignment, timeType, className, } = this.props;
        return (React.createElement("div", { ...this.getDataAttributes(), "data-hook": this.props['data-hook'], className: st(classes.root, { stretchable, current, alignment, timeType }, className) },
            React.createElement("div", { className: classes.innerContainer },
                React.createElement(Text, { className: classes.title }, title),
                children)));
    }
}
CalendarCell.displayName = 'CalendarCell';
CalendarCell.defaultProps = {
    stretchable: false,
    current: false,
    alignment: CalendarCellAlignment.left,
    timeType: CalendarCellTimes.futureDate,
};
//# sourceMappingURL=CalendarCell.js.map